<template>
  <b-card style="scroll-margin-top: 60px; width: 100%" no-body class="mb-4 border-0">
    <b-card-header
      header-tag="header"
      class="py-3 px-4 pointer border-0 export-toggle-header"
      role="tab"
      v-b-toggle="'export'"
    >
      <div class="d-flex flex-row align-items-center">
        <i class="fas fa-sort-down mr-3" />
        <h5 class="mb-0">
          {{ $t('export.export_settings') }}
        </h5>
      </div>
    </b-card-header>

    <b-collapse
      :visible="opened"
      id="export"
      @hide="$emit('hide')"
      @show="$emit('show')"
      accordion="my-accordion"
      role="tabpanel"
    >
      <b-card-body class="px-4 pb-0">
        <div class="mb-3 export-help">
          {{ $t('export.export_help') }}
        </div>
        <div>
          <b-nav>
            <b-nav-item active></b-nav-item>
            <b-nav-item></b-nav-item>
          </b-nav>
        </div>
        <div>
          <b-tabs content-class="mt-3" class="export-tabs">
            <b-tab title="Export" active>
              <div>
                <label for="export-fields">
                  {{ $t('export.export_fields') }}
                </label>
              </div>
              <treeselect
                  ref="treeselect"
                  id="export-fields"
                  v-model="fields"
                  class="mb-3"
                  :multiple="true"
                  :value-consists-of="'LEAF_PRIORITY'"
                  :value-format="'object'"
                  :normalizer="normalizer"
                  :options="getTreeselectOptions"
              >
          <span slot="value-label" slot-scope="{ node }">{{
              node.raw.customTitle ? node.raw.customTitle : node.label
            }}</span>
                <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    style="display: flex; align-items: center; margin: 5px 0"
                    :class="labelClassName"
                >
            <span style="white-space: nowrap">
              {{ node.label }}
            </span>
                  <template v-if="!node.isBranch">
                    <b-form-input
                        v-model="node.raw.customTitle"
                        @mousedown="handleInputClick"
                        class="ml-2"
                        type="text"
                    />
                  </template>
                </label>
              </treeselect>
              <div>
                <label for="title">
                  {{ $t('export.export_title') }}
                </label>
              </div>
              <b-input
                  v-model="exportTitle"
                  id="title"
                  type="email"
                  label="Export title"
                  class="w-100 rounded mb-3"
                  style="height: 35px"
                  name="title"
                  :placeholder="$t('export.export_title_placeholder')"
              />
              <div>
                <label for="recipient_email">
                  {{ $t('export.recipient_email') }}
                </label>
              </div>
              <b-input
                  v-model="recipientEmail"
                  id="recipient_email"
                  type="email"
                  label="Recipient email"
                  class="w-100 rounded mb-3"
                  style="height: 35px"
                  name="recipient_email"
                  :placeholder="$t('export.recipient_email_placeholder')"
              />
              <b-button :disabled="!fields.length" @click="startExport" style="margin-top: 10px; margin-bottom: 32px">
                {{ $t('global.generate_send_on_email') }}
              </b-button>

              <h5 class="mb-0 mt-3">
                {{ $t('export.export_history') }}
              </h5>

              <v-server-table
                  ref="exportsTable"
                  name="exportsTable"
                  :url="tableUrl"
                  :columns="columns"
                  :options="tableOptions"
                  @loaded="loading = false"
                  @loading="loading = true"
              >
                <template slot="beforeLimit" v-if="totalRecordsCount > 10">
                  {{ $t('global.showing') }}&nbsp;
                </template>
                <template slot="afterLimit" v-if="totalRecordsCount > 10">
                  &nbsp;{{ $t('global.of_records_found', { number: totalRecordsCount }) }}
                </template>
                <template slot="id" slot-scope="props">
                  <router-link
                      :to="{ path: `/export/${props.row.id}`, params: props.row }"
                      target="_blank"
                  >
                    {{ props.row.id }}
                  </router-link>
                </template>
                <template slot="created_at" slot-scope="props">
                  <column-date :row="props.row" column="created_at" format="L" />
                </template>
                <template slot="generated_at" slot-scope="props">
                  <column-date :row="props.row" column="generated_at" format="L" />
                </template>
                <template slot="status" slot-scope="props">
                  <column-status
                      column="status"
                      :row="props.row"
                      @refreshTable="$refs.exportsTable.refresh"
                  />
                </template>
                <template slot="actions" slot-scope="props">
                  <b-button
                      v-if="props.row.status == 'success'"
                      @click="download(props.row)"
                      variant="outline-primary"
                      class="border-0 p-1"
                      style="height: 34px; width: 34px"
                  >
                    <i class="fa fa-download" />
                  </b-button>
                </template>
              </v-server-table>
            </b-tab>

            <b-tab title="Scheduled export">
              <div>
                <label for="scheduled_frequency">
                  {{ $t('export.schedule_frequency') }}
                </label>
              </div>
              <b-form-select
                  v-model="scheduleFrequency"
                  id="scheduled_frequency"
                  :options="scheduleOptions"
                  class="mb-3"
                  style="width: 100%;"
              ></b-form-select>

              <div>
                <label for="export-fields-scheduled">
                  {{ $t('export.export_fields') }}
                </label>
              </div>
              <treeselect
                  id="export-fields-scheduled"
                  ref="scheduledTreeselect"
                  v-model="scheduleFields"
                  class="mb-3"
                  :multiple="true"
                  :value-consists-of="'LEAF_PRIORITY'"
                  :value-format="'object'"
                  :normalizer="scheduleNormalizer"
                  :options="getTreeselectOptions"
              >
  <span slot="value-label" slot-scope="{ node }">{{
      node.raw.customTitle ? node.raw.customTitle : node.label
    }}</span>
                <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    style="display: flex; align-items: center; margin: 5px 0"
                    :class="labelClassName"
                >
    <span style="white-space: nowrap">
      {{ node.label }}
    </span>
                  <template v-if="!node.isBranch">
                    <b-form-input
                        v-model="node.raw.customTitle"
                        @mousedown="scheduleHandleInputClick"
                        class="ml-2"
                        type="text"
                    />
                  </template>
                </label>
              </treeselect>

              <div>
                <label for="scheduled_title">
                  {{ $t('export.export_title') }}
                </label>
              </div>
              <b-input
                  v-model="scheduledTitle"
                  id="scheduled_title"
                  type="text"
                  label="Export title"
                  class="w-100 rounded mb-3"
                  style="height: 35px"
                  :placeholder="$t('export.export_title_placeholder')"
              />
              <div>
                <label for="scheduled_recipient_email">
                  {{ $t('export.recipient_email') }}
                </label>
              </div>
              <b-input
                  v-model="scheduledRecipientEmail"
                  id="scheduled_recipient_email"
                  type="email"
                  label="Recipient email"
                  class="w-100 rounded mb-3"
                  style="height: 35px"
                  :placeholder="$t('export.recipient_email_placeholder')"
              />

              <b-button
                  :disabled="!fields.length"
                  @click="scheduleExport"
                  style="margin-top: 10px; margin-bottom: 32px"
              >
                {{ $t('export.scheduled_export') }}
              </b-button>

              <h5 class="mb-0 mt-3">
                {{ $t('export.scheduled_export_history') }}
              </h5>
              <v-server-table
                  ref="scheduledExportsTable"
                  name="scheduledExportsTable"
                  :url="scheduledTableUrl"
                  :columns="scheduledColumns"
                  :options="scheduledTableOptions"
                  @loaded="scheduledLoading = false"
                  @loading="scheduledLoading = true"
              >
                <template slot="beforeLimit" v-if="totalRecordsCountScheduled > 10">
                  {{ $t('global.showing') }}&nbsp;
                </template>
                <template slot="afterLimit" v-if="totalRecordsCountScheduled > 10">
                  &nbsp;{{ $t('global.of_records_found', { number: totalRecordsCountScheduled }) }}
                </template>
                <template slot="frequency" slot-scope="props">
                  {{ props.row.frequency }}
                </template>
                <template slot="recipient_email" slot-scope="props">
                  {{ props.row.recipient_email }}
                </template>
                <template slot="active" slot-scope="props">
                  <column-check :row="props.row" column="active" @refreshTable="$refs.scheduledExportsTable.refresh" />
                </template>
                <template slot="generated_at" slot-scope="props">
                  <column-date :row="props.row" column="created_at" format="L" />
                </template>
                <template slot="updated_at" slot-scope="props">
                  <column-date :row="props.row" column="updated_at" format="L" />
                </template>
                <template slot="actions" slot-scope="props">
                  <column-action
                      :delete-url="`/export-requests/scheduler/${props.row.id}`"
                      :route="{path: `/users/edit/export/${props.row.id}`, params: props.row}"
                      @deleteItems="refreshTable('scheduledExportsTable')"
                  />
                </template>
              </v-server-table>
            </b-tab>
          </b-tabs>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import axios from '@/utils/axios';
import { Event } from 'vue-tables-2';
import i18n from '@/utils/i18n';
import Cookies from 'js-cookie';

export default {
  name: 'ExportSection',
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
      default: '',
    },
    opened: {
      type: Boolean,
      default: false,
    },
    params: {
      id: {
        type: Number
      }
    },
  },
  data() {
    return {
      scheduledFields: [],
      scheduleFrequency: '1 day',
      scheduleOptions: [
        { value: '1 day', text: '1 Day' },
        { value: '7 days', text: '7 Days' },
        { value: '1 month', text: '1 Month' },
        { value: '3 months', text: '3 Months' },
      ],
      scheduledTitle: null,
      scheduledRecipientEmail: null,
      scheduledColumns: [
        'id',
        'title',
        'recipient_email',
        'frequency',
        'active',
        'generated_at',
        'updated_at',
        'actions',
      ],
      scheduledTableUrl: '/admin/export-requests/users/scheduler',
      scheduledTableOptions: {
        skin: [],
        headings: {
          id: '#',
          title: i18n.t('form.title'),
          recipient_email: i18n.t('export.recipient_email'),
          frequency: i18n.t('export.frequency'),
          status: i18n.t('form.status'),
          generated_at: i18n.t('form.generated_at'),
          updated_at: i18n.t('form.updated_at'),
          actions: i18n.t('global.actions'),
          active: i18n.t('export.scheduled_status'),
        },
        dateColumns: ['generated_at', 'updated_at'],
        sortable: [],
        perPage: 10,
        filterable: false,
        requestFunction: function (data) {
          return axios.get(this.url, { params: data }).catch((e) => {
            this.dispatch('error', e);
          });
        },
        responseAdapter: function (resp) {
          let { data } = this.getResponseData(resp);
          return {
            data: data.items,
            count: data.paginator.total_items,
          };
        },
      },
      scheduledLoading: false,
      exportAvailableFields: {},
      totalRecordsCount: null,
      totalRecordsCountScheduled: null,
      columns: ['id', 'title', 'status', 'created_at', 'generated_at', 'total_rows', 'actions'],
      tableOptions: {
        skin: [],
        headings: {
          id: '#',
          title: i18n.t('form.title'),
          status: i18n.t('form.status'),
          created_at: i18n.t('form.created_at'),
          generated_at: i18n.t('form.generated_at'),
          total_rows: i18n.t('form.total_rows'),
          actions: i18n.t('global.actions'),
        },
        dateColumns: ['created_at', 'generated_at'],
        sortable: [],
        clientMultiSorting: false,
        perPage:
          !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== ''
            ? localStorage.getItem('perPage')
            : 10,
        filterable: false,
        requestFunction: function (data) {
          let params = {};
          params.limit = data.limit;
          params.page = data.page;

          localStorage.setItem('perPage', data.limit);
          return this.url
            ? axios.get(this.url, { params: data }).catch((e) => {
                this.dispatch('error', e);
              })
            : Promise.resolve();
        },
        responseAdapter: function (resp) {
          let { data } = this.getResponseData(resp);
          return {
            data: data.items,
            count: data.paginator.total_items,
          };
        },
      },
      fields: [],
      scheduleFields: [],
      lastFields: [],
      flatOptions: {},
      flatCustomOptions: {},
      recipientEmail: null,
      exportTitle: null,
      isFieldsLoaded: false,
      tableUrl: null,
      defaultFields: [
        {
          key: 'user.id',
          title: 'User ID',
        },
        {
          key: 'user.email',
          title: 'Email',
        },
        {
          key: 'user.first_name',
          title: 'First Name',
        },
        {
          key: 'user.last_name',
          title: 'Last Name',
        },
        {
          key: 'user.company',
          title: 'Company',
        },
        {
          key: 'user.job',
          title: 'Job',
        },
        {
          key: 'user_plan.plan.title',
          title: 'Plan Title',
        },
        {
          key: 'user_plan.subscription.title',
          title: 'Subscription Title',
        },
        {
          key: 'user_plan.created_at',
          title: 'Subscription Start date',
        },
        {
          key: 'user_plan.subscription_end_date',
          title: 'Subscription End Date',
        },
        {
          key: 'user_plan.autorenew',
          title: 'Autorenew',
        },
        {
          key: 'user_plan.is_trial',
          title: 'Trial',
        },
      ],
    };
  },
  mounted() {
    this.$emit('hide');

    // Handler to prevent default behavior on treeselect
    document.getElementsByClassName('vue-treeselect__input')[0].addEventListener(
      'blur',
      (event) => {
        event.stopImmediatePropagation();
      },
      true,
    );

    Event.$on('vue-tables.exportsTable.loaded', ({ data }) => {
      this.totalRecordsCount = data.paginator.total_items;
    });
    Event.$on('vue-tables.scheduledExportsTable.loaded', ({ data }) => {
      this.totalRecordsCountScheduled = data.paginator.total_items;
    });
  },
  watch: {
    opened(newState) {
      if (newState && !this.isFieldsLoaded) {
        this.getAvailableFields();
        this.getAvailableFieldsSchedule();
        this.tableUrl = '/admin/export-requests/users/list';
        this.isFieldsLoaded = true;
      }
    },
  },
  methods: {
    handleInputClick(event) {
      event.stopPropagation();
      event.target.focus();
    },
   scheduleHandleInputClick(event) {
      event.stopPropagation();
      event.target.focus();
    },
    normalizer(node) {
      return {
        id: node.key,
        label: node.title,
        children: node.children,
        customTitle: node.customTitle,
      };
    },
    scheduleNormalizer(node) {
      return {
        id: node.key,
        label: node.title,
        children: node.children,
        customTitle: node.customTitle,
      };
    },
    startExport() {
      this.postData(`export-requests/users/generate`, {
        title: this.exportTitle && this.exportTitle.length > 0 ? this.exportTitle : null,
        recipient_email:
          this.recipientEmail && this.recipientEmail.length > 0 ? this.recipientEmail : null,
        filters: this.filters,
        fields: this.fieldsForRequest,
      }).then(() => {
        this.refreshTable('exportsTable');
      });
    },
    scheduleExport() {
      this.postData(`export-requests/users/scheduler`, {
        frequency: this.scheduleFrequency && this.scheduleFrequency.length > 0 ? this.scheduleFrequency : null,
        title: this.scheduledTitle && this.scheduledTitle.length > 0 ? this.scheduledTitle : null,
        recipient_email:
          this.scheduledRecipientEmail && this.scheduledRecipientEmail.length > 0 ? this.scheduledRecipientEmail : null,
        filters: this.filters,
        fields: this.fieldsForRequestScheduled,
      }).then(() => {
        this.refreshTable('scheduledExportsTable');
      });
    },
    download(exportRequest) {
      const token = Cookies.get('token');

      axios({
        url: exportRequest.download_link,
        method: 'GET',
        responseType: 'blob',
        headers: {
          token,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${exportRequest.id}.xlsx`);
        link.click();
      });
    },
    getOptionsObject(option) {
      // recursive method
      let defaultOptions = {};
      if (Array.isArray(option) && option.length > 0) {
        option.forEach((element) => {
          defaultOptions[element.key] = element.title;
        });
      } else if (typeof option === 'object' && option.key === undefined) {
        Object.keys(option).forEach((key) => {
          Object.assign(defaultOptions, this.getOptionsObject(option[key]));
        });
      }
      return defaultOptions;
    },
    getAvailableFields() {
      this.getData(`export-requests/users/fields`, null, false).then(({ data }) => {
        this.exportAvailableFields = data.items;
        this.flatOptions = this.getOptionsObject(data.items);
        this.getLastFields();
      });
    },
    getLastFields() {
      return this.getData(`export-requests/users/last-fields`, null, false).then(({ data }) => {
        this.lastFields = data.fields.length ? data.fields : this.defaultFields;
        this.flatCustomOptions = this.getOptionsObject(this.lastFields);
        this.fields = this.addDefaultTitles(this.lastFields);
      });
    },
    getAvailableFieldsSchedule() {
      this.getData(`export-requests/users/fields`, null, false).then(({ data }) => {
        this.exportAvailableFields = data.items;
        this.flatOptions = this.getOptionsObject(data.items);
        this.getLastFieldsSchedule();
      });
    },
    getLastFieldsSchedule() {
      return this.getData(`export-requests/users/last-fields`, null, false).then(({ data }) => {
        this.lastFields = data.fields.length ? data.fields : this.defaultFields;
        this.flatCustomOptions = this.getOptionsObject(this.lastFields);
        this.scheduleFields = this.addDefaultTitles(this.lastFields);
      });
    },
    addDefaultTitles(fields) {
      return fields.map((field) =>
        this.flatOptions[field.key] === field.title
          ? field
          : { key: field.key, title: this.flatOptions[field.key], customTitle: field.title },
      );
    },
    recursionParse(el, key) {
      let children = [];

      if (Array.isArray(el) && el.length > 0) {
        el.map((option) => {
          children.push({
            key: option.key,
            title: option.title,
            customTitle:
              this.flatCustomOptions[option.key] &&
              this.flatCustomOptions[option.key] !== option.title
                ? this.flatCustomOptions[option.key]
                : '',
          });
        });
      } else if (typeof el === 'object' && el.key === undefined) {
        Object.keys(el).forEach((key, index) => {
          let child = this.recursionParse(el[key], key);
          if (child) {
            children.push(child);
          }
        });
      } else {
        console.log('Error type element: ', el);
      }

      if (children.length > 0) {
        if (key) {
          return { key: Math.random() + key, title: key, children: children };
        }
        return children;
      }
      return null;
    },
  },
  computed: {
    getTreeselectOptions: function () {
      return this.recursionParse(this.exportAvailableFields);
    },
    fieldsForRequest: function () {
      return this.fields.map((el) => {
        return {
          key: el.key,
          title: el.customTitle !== '' ? el.customTitle : el.title,
        };
      });
    },
    fieldsForRequestScheduled: function () {
      return this.scheduleFields.map((el) => {
        return {
          key: el.key,
          title: el.customTitle !== '' ? el.customTitle : el.title,
        };
      });
    },
  },
};
</script>

<style scoped>
  .export-toggle-header {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: #ffffff;
    h5 {
      font-size: 22px;
      padding-top: 4px;
    }
  }
  .export-help {
    font-size: 16px;
    line-height: 24px;
  }
</style>